import React, { useState, useEffect } from "react";
import axios from "axios";
import img from "../../../assets/Icon/Rejected.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const RejectedLearningSession = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/star/learning_session/reject`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Rejected Learning Session"
        image={img}
        count={count}
      />
      {buffer ? (
          <LoaderPost />
        ) : (
      <AllModuleData
        data={event_data}
        urlLink={`/superstar/learning-session/details`}
      />
      )}
    </>
  );
};

export default RejectedLearningSession;
